import React from "react";

const UnsupportedBrowser = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f3f4f6",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow:
            "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
          padding: "32px",
          maxWidth: "384px",
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Header */}
        <h1
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#ef4444",
            marginBottom: "24px",
            lineHeight: "1.2",
          }}
        >
          Unsupported
          <br />
          Browser
        </h1>

        {/* Message */}
        <p
          style={{
            color: "#374151",
            fontSize: "14px",
            marginBottom: "32px",
            lineHeight: "1.6",
          }}
        >
          This Application not to be use in mobile.
        </p>

        {/* Browser Icons */}
        <div style={{ marginBottom: "32px" }}>
          {/* Chrome and Firefox row */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "24px",
              marginBottom: "16px",
            }}
          >
            {/* Chrome */}
            <a
              href="https://www.google.com/chrome/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <img
                src="https://tse2.mm.bing.net/th/id/OIP.0LK8ssQgCS9CM4K8zUH5-gHaHa?rs=1&pid=ImgDetMain&o=7&rm=3"
                alt="Google Chrome"
                style={{
                  width: "64px",
                  height: "64px",
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>

            {/* Firefox */}
            <a
              href="https://www.mozilla.org/en-US/firefox/new/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <img
                src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/firefox/firefox.svg"
                alt="Mozilla Firefox"
                style={{
                  width: "64px",
                  height: "64px",
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>
          </div>

          {/* Edge */}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a
              href="https://www.microsoft.com/en-us/edge"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <img
                src="https://cdn.jsdelivr.net/gh/alrra/browser-logos/src/edge/edge.svg"
                alt="Microsoft Edge"
                style={{
                  width: "64px",
                  height: "64px",
                  cursor: "pointer",
                  transition: "transform 0.2s ease",
                }}
                onMouseEnter={(e) => (e.target.style.transform = "scale(1.05)")}
                onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
              />
            </a>
          </div>
        </div>

        {/* Footer text */}
        <p
          style={{
            color: "#6b7280",
            fontSize: "14px",
          }}
        >
          Click on a browser logo to download a supported browser.
        </p>
      </div>
    </div>
  );
};

export default UnsupportedBrowser;
